import { Typography } from "@material-ui/core";
import classNames from "classnames";
import moment from "moment";
import { DefaultCard, useDefaultCardStyles } from "../../../../../components/cards/components";
import { MovimentacaoCompraResponse } from "../../models/envio-movimentacao.model";
import { useStyles } from "../envio-movimentacao-listagem-styles";

interface MovimentacaoCompraListaProps {
  listaCompra: MovimentacaoCompraResponse[];
}

export const MovimentacaoCompraLista: React.FC<MovimentacaoCompraListaProps> = ({ listaCompra }) => {

  const styles = useStyles();
  const classesCard = useDefaultCardStyles();

  return (
    <div>
      {
        listaCompra?.map((row, index) => (

          <div className={`flex-column w-100 ${styles.cardMovimentacaoItem}`} key={index}>

            <DefaultCard className={styles.cardContainer}>

              <div className={`flex-row w-100 h-100`}>
                <div className={classNames(classesCard.tagStatus, styles.statusColor)} />

                <div className={`flex-row w-100 ${classesCard.infoContainer}`}>

                  <div className={`flex-column ${classesCard.inputMinWidth}`}>
                    <Typography className={classesCard.labelFont}>
                      Data Lançamento:
                    </Typography>
                    <Typography className={classesCard.contentFont}>
                      {moment(row.dataLancamento).format("DD/MM/YYYY")}
                    </Typography>
                  </div>

                  <div className={`flex-column ${classesCard.inputMinWidth}`}>
                    <Typography className={classesCard.labelFont}>
                      Data da N.F:
                    </Typography>
                    <Typography className={classesCard.contentFont}>
                      {moment(row.dataNotaFiscal).format("DD/MM/YYYY")}
                    </Typography>
                  </div>

                  <div className={`flex-column ${classesCard.inputMinWidth}`}>
                    <Typography className={classesCard.labelFont}>
                      N° da Nota Fiscal:
                    </Typography>
                    <Typography className={classesCard.contentFont}>
                      {row.numeroNotaFiscal ?? 0}
                    </Typography>
                  </div>

                  <div className={`flex-column ${classesCard.inputMinWidth}`}>
                    <Typography className={classesCard.labelFont}>
                      CNPJ do Fornecedor:
                    </Typography>
                    <Typography className={classesCard.contentFont}>
                      {row.cnpjFornecedor ?? 0}
                    </Typography>
                  </div>

                  <div className={`flex-column ${classesCard.inputMinWidth}`}>
                    <Typography className={classesCard.labelFont}>
                      Nome:
                    </Typography>
                    <Typography className={classesCard.contentFont}>
                      {row.nomeFornecedor ?? '--'}
                    </Typography>
                  </div>

                </div>
              </div>

            </DefaultCard>

          </div>
        ))
      }
    </div>
  )
}